module.exports = __webpack_public_path__ + "img/018.84d9dc6c.jpg";